import React from 'react';
import { Button } from 'react-bootstrap';

import Table from '../../../../../facturotopia/table/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DocumentosRelacionadosList = ({ data = [], onEdit, onDelete }) => {
  const handleEdit = (item) => {
    onEdit(item);
  };

  const handleDelete = (item) => {
    onDelete(item);
  };

  return (
    <Table
      columns={columns(handleEdit, handleDelete)}
      rowKey={'id'}
      data={data}
    />
  );
};

const columns = (handleEdit, handleDelete) => [
  {
    align: 'center',
    key: '__',
    title: '',
    dataIndex: '__',
    render: (item) => {
      return (
        <>
          <Button
            data-test-id={`pagos-lista-editar-${item?.IdDocumento}`}
            variant="secondary"
            size="sm"
            onClick={handleEdit.bind(null, item)}
          >
            <FontAwesomeIcon icon={['far', 'edit']} />
          </Button>
          <Button
            data-test-id={`pagos-lista-eliminar-${item?.IdDocumento}`}
            variant="danger"
            size="sm"
            onClick={handleDelete.bind(null, item)}
          >
            <FontAwesomeIcon icon={['fas', 'trash']} />
          </Button>
        </>
      );
    },
  },
  {
    align: 'center',
    key: 'IdDocumento',
    title: 'Folio Fiscal',
    dataIndex: 'IdDocumento',
  },
  {
    align: 'center',
    key: 'Serie',
    title: 'Serie',
    dataIndex: 'Serie',
  },
  {
    align: 'center',
    key: 'Folio',
    title: 'Folio',
    dataIndex: 'Folio',
  },
  {
    align: 'center',
    key: 'MonedaDR',
    title: 'Moneda',
    dataIndex: 'MonedaDR',
  },
  {
    align: 'center',
    key: 'NumParcialidad',
    title: 'Número de parcialidad',
    dataIndex: 'NumParcialidad',
  },
  {
    align: 'right',
    key: 'ImpSaldoAnt',
    title: 'Importe saldo anterior',
    dataIndex: 'ImpSaldoAnt',
  },
  {
    align: 'right',
    key: 'ImpPagado',
    title: 'Importe pagado',
    dataIndex: 'ImpPagado',
  },
  {
    align: 'right',
    key: 'ImpSaldoInsoluto',
    title: 'Importe saldo insoluto',
    dataIndex: 'ImpSaldoInsoluto',
  },
];

export default DocumentosRelacionadosList;
